/**
 * Access-token seam for the HTTP client.
 *
 * The token lives in memory inside the Auth0 SDK and is never written to
 * localStorage or sessionStorage (docs/00-overview.md §5.1). The API layer is
 * not a React component, so it cannot read it from context — the active auth
 * provider registers a getter here on mount and the client calls it per request.
 *
 * Nothing calls `getAccessToken` yet: `src/api` is still the mock adapter. It
 * exists so the fetch client APP-51 brings has one place to get a bearer token
 * from, rather than reaching into the provider.
 */

type TokenGetter = () => Promise<string | null>

let getter: TokenGetter = async () => null

export function setTokenGetter(next: TokenGetter): () => void {
  getter = next
  return () => {
    if (getter === next) getter = async () => null
  }
}

export function getAccessToken(): Promise<string | null> {
  return getter()
}
